import { render, staticRenderFns } from "./LoginStaff.vue?vue&type=template&id=77a7e87d&"
import script from "./LoginStaff.vue?vue&type=script&lang=js&"
export * from "./LoginStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports